import React, { useContext } from "react"
import { LanguageContext } from "../context/LanguageContext"
import { NAV_HEADER } from "../constants/text";
import "../styles/common.scss"

const Nav = (props) => {
  const { languageToUse } = useContext(LanguageContext);
  return (
    <nav className="nav">
      <section>
        <h1>{NAV_HEADER.name}</h1>
      </section>
    </nav>
  )
}

export default Nav
